import { initializeApp } from "firebase/app";
import { getDatabase, ref, get } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyC6kNDRi7fC2e3i2AqVTT_Wph-ehL5dmYA",
  authDomain: "quiz-11-9dca6.firebaseapp.com",
  projectId: "quiz-11-9dca6",
  storageBucket: "quiz-11-9dca6.firebasestorage.app",
  messagingSenderId: "408282991747",
  appId: "1:408282991747:web:892fdfc1989a85be921fb6",
  databaseURL: "https://quiz-11-9dca6-default-rtdb.asia-southeast1.firebasedatabase.app"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

// Pre-connect: Make a lightweight query on load to warm up connection
const preconnect = async () => {
  try {
    const testRef = ref(database, '.info/connected');
    await get(testRef);
    console.log('✅ Firebase pre-connected');
  } catch (error) {
    console.warn('Firebase pre-connect failed:', error);
  }
};

// Call immediately
preconnect();

export { app, database };
